const initImageViewer = () => {
  const images = document.querySelectorAll('img.checkoff-image-frame, .checkoff-image-frame img');
  if (!images.length || typeof HTMLDialogElement === 'undefined') return;

  const dialog = document.createElement('dialog');
  dialog.className = 'checkoff-image-viewer';
  dialog.setAttribute('aria-label', 'Enlarged image');
  dialog.innerHTML = `
    <div class="checkoff-image-viewer__tools">
      <button type="button" data-action="in" aria-label="Zoom in" title="Zoom in"><i class="fa fa-search-plus" aria-hidden="true"></i></button>
      <button type="button" data-action="out" aria-label="Zoom out" title="Zoom out"><i class="fa fa-search-minus" aria-hidden="true"></i></button>
      <button type="button" data-action="reset" aria-label="Fit image" title="Fit image"><i class="fa fa-compress" aria-hidden="true"></i></button>
      <button type="button" data-action="close" aria-label="Close image" title="Close image"><i class="fa fa-times" aria-hidden="true"></i></button>
    </div>
    <div class="checkoff-image-viewer__viewport" tabindex="0" role="region" aria-label="Image: scroll to explore">
      <img alt="">
    </div>`;
  document.body.appendChild(dialog);
  const viewport = dialog.querySelector('.checkoff-image-viewer__viewport');
  const enlarged = viewport.querySelector('img');
  let scale = 1;
  let trigger;
  let previousOverflow;

  const render = () => {
    if (!enlarged.naturalWidth) return;
    const fit = Math.min(viewport.clientWidth / enlarged.naturalWidth,
      viewport.clientHeight / enlarged.naturalHeight, 1);
    enlarged.style.width = `${enlarged.naturalWidth * fit * scale}px`;
    dialog.querySelector('[data-action="out"]').disabled = scale <= 1;
    dialog.querySelector('[data-action="in"]').disabled = scale >= 4;
  };
  enlarged.addEventListener('load', render);
  window.addEventListener('resize', () => { if (dialog.open) render(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (trigger) trigger.focus();
  });
  dialog.addEventListener('click', (event) => {
    const control = event.target.closest('[data-action]');
    if (!control) return;
    const action = control.dataset.action;
    if (action === 'close') { dialog.close(); return; }
    const oldScale = scale;
    const centerX = viewport.scrollLeft + viewport.clientWidth / 2;
    const centerY = viewport.scrollTop + viewport.clientHeight / 2;
    scale = action === 'reset' ? 1 : Math.max(1, Math.min(4, scale + (action === 'in' ? 0.5 : -0.5)));
    render();
    viewport.scrollLeft = centerX * scale / oldScale - viewport.clientWidth / 2;
    viewport.scrollTop = centerY * scale / oldScale - viewport.clientHeight / 2;
  });

  images.forEach((img) => {
    const link = img.closest('a');
    const opener = link || img;
    if (!link) {
      opener.tabIndex = 0;
      opener.setAttribute('role', 'button');
    }
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.setAttribute('aria-label', `Enlarge image${img.alt ? `: ${img.alt}` : ''}`);
    opener.classList.add('checkoff-image-viewer-trigger');
    const open = (event) => {
      event.preventDefault();
      trigger = opener;
      scale = 1;
      enlarged.alt = img.alt;
      enlarged.removeAttribute('style');
      enlarged.src = img.dataset.fullImage || img.currentSrc || img.src;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      render();
      viewport.scrollTo(0, 0);
    };
    opener.addEventListener('click', open);
    opener.addEventListener('keydown', (event) => {
      if (event.key === ' ' || (!link && event.key === 'Enter')) open(event);
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageViewer);
} else {
  initImageViewer();
}
